"use strict";
let projectId,
  idenStr,
  appScenarios,
  /* 
	挖坑对象
	  terrainClip 挖坑的图层
	  areaItem 所有坑的集合
	*/
  terrainClip,
  areaItemT8,
  areaItem = {},
  graphicDotsine;
let isDftSkyBox = false;
import bMap from "../../components/mars3d/Map.vue";

import initPlatformSettings from "@/components/tables/basicSettings/config/index.js";
import { exposureEnvironmentSettings } from "@/components/tables/basicSettings/config/environmentConfig.js";
import * as programmeSimulationMap from "@/components/tables/Timeline/programmeSimulation.js";

//按需加载
import {
  getProjectBimModel,
  getProjectGisInfo,
  getProjectShpInfo,
  getProjectGisModify,
  getProjectPageGisModify,
  getProjectSettings,
  menuChange,
  getKmlInfo,
  getBimModelAttributesList,
  // getModelPropertyList,
} from "../../api/api";
import axios from "axios";
import { T7Digdata } from "./T7.js";
// import { T8Digdata } from "./T8.js";
import * as basicSettingMW from "@/components/tables/basicSettings/map.js";
/* 异步加载 一些弹窗组件 */
const MarkList = () => import("../../components/tables/markList/MarkList.vue");
const Measure = () => import("../../components/tables/measure/Measure.vue");
const Transparency = () =>
  import("../../components/tables/transparency/Transparency.vue");
const BasicSkills = () =>
  import("../../components/tables/basicSkills/BasicSkills.vue");
const DrawLine = () => import("../../components/tables/drawLine/DrawLine.vue");
const ModelCut = () => import("../../components/tables/modelCut/ModelCut.vue");
const ProfileAnalysis = () =>
  import("../../components/tables/profileAnalysis/ProfileAnalysis.vue");
const ModelCrop = () =>
  import("../../components/tables/modelCrop/ModelCrop.vue");
const RouteRoaming = () =>
  import("../../components/tables/routeRoaming/RouteRoaming.vue");
const CustomRoaming = () =>
  import("../../components/tables/customRoaming/CustomRoaming.vue");
const VideoRoaming = () =>
  import("../../components/tables/videoRoaming/VideoRoaming.vue");
const StationQuery = () =>
  import("../../components/tables/stationQuery/Index.vue");
const routeInteraction = () =>
  import("../../components/tables/routeInteraction/index.vue");
const newRouteInteraction = () =>
  import("../../components/tables/newRouteInteraction/index.vue");
const lineElInfo = () =>
  import("../../components/tables/routeInteraction/lineElInfo.vue");
const drawCrossSection = () =>
  import("../../components/tables/routeInteraction/drawCrossSection.vue");
const statisticsEarthwork = () =>
  import("../../components/tables/routeInteraction/statisticsEarthwork.vue");
const HundredStake = () =>
  import("../../components/tables/hundredStake/Index.vue");
const LabelList = () =>
  import("../../components/tables/labelList/LabelList.vue");

/* 异步加载 色彩主题组件 */
const ThemeChoose = () =>
  import("../../components/customize/themeChoose/ThemeChoose.vue");

/* 异步加载 模型属性组件 */
const PropertyList = () =>
  import("../../components/tables/propertyList/PropertyList.vue");

/* 异步加载 模型透明度组件 */
const ModelTransparency = () =>
  import("../../components/tables/modelTransparency/ModelTransparency.vue");

/* 异步加载 基本设置组件 */
const BasicSettings = () =>
  import("../../components/tables/basicSettings/BasicSettings.vue");

/* 异步加载 GIS(地形高程和影像)组件 */
const TerrainElevation = () =>
  import("../../components/tables/terrainElevation/TerrainElevation.vue");

/* 异步加载 等高线组件 */
const ContourLine = () =>
  import("../../components/tables/contourLine/ContourLine.vue");

/* 异步加载 日照分析组件 */
const SunshineAnalysis = () =>
  import("../../components/tables/sunshineAnalysis/SunshineAnalysis.vue");

/* 异步加载 模型压平组件 */
const ModelFlattening = () =>
  import("../../components/tables/modelFlattening/ModelFlattening.vue");
/* 异步加载 地形挖洞组件 */
const TerrainDigging = () =>
  import("../../components/tables/terrainDigging/TerrainDigging.vue");
/* 异步加载 新地形挖洞组件 */
const NewTerrainDigging = () =>
  import("../../components/tables/newTerrainDigging/Index.vue");

/* 异步加载 模型旋转组件 */
const ModelRotation = () =>
  import("../../components/tables/modelRotation/ModelRotation.vue");

/* 异步加载 模型平移组件 */
const ModelTranslation = () =>
  import("../../components/tables/modelTranslation/ModelTranslation.vue");

/* 异步加载 ShpInfo目录树组件 */
const ShpInfoList = () =>
  import("../../components/tables/shpInfoList/ShpInfoList.vue");

/* 异步加载 场景设置组件 */
const ScenesSettings = () =>
  import("../../components/tables/scenesSettings/ScenesSettings.vue");

/* 异步加载 特效效果组件 */
const SpecialEffects = () =>
  import("../../components/tables/specialEffects/SpecialEffects.vue");

/* 异步加载 输出（场景出图）组件 */
const ScenePlot = () =>
  import("../../components/tables/scenePlot/ScenePlot.vue");

/* 异步加载 地形修改 组件 */
const TerrainModify = () =>
  import("../../components/tables/terrainModify/TerrainModify.vue");

/* 异步加载 视频监控管理 组件 */
const BimVideo = () => import("../../components/tables/bimVideo/BimVideo.vue");

const BimVideoCategory2 = () =>
  import("../../components/tables/bimVideoCategory2/Index.vue");

/* 异步加载 监测管理 组件 */
const BimMonitor = () =>
  import("@/components/tables/bimMonitor/BimMonitor.vue");

/* 异步加载 征拆区域管理 组件 */
const BimDemolition = () =>
  import("../../components/tables/bimDemolition/BimDemolition.vue");

/* 异步加载 变更管理 组件 */
const BimEngineeringChange = () =>
  import(
    "../../components/tables/bimEngineeringChange/BimEngineeringChange.vue"
  );

const newBimEngineeringChange = () =>
  import("../../components/tables/newBimEngineeringChange/Index.vue");

const bimModelAttributes = () =>
  import("@/components/tables/bimModelAttributes/Index.vue");

// const Program = () => import("@/components/tables/program/Index.vue");
const PlanDemo = () => import("../../components/tables/planDemo/PlanDemo.vue");
const Vehicle = () => import("../../components/tables/vehicle/Vehicle2.vue");

const programme1 = () =>
  import("@/components/tables/constructionProgramme/programme1.vue");
const programme2 = () =>
  import("@/components/tables/constructionProgramme/programme2.vue");
const programme3 = () =>
  import("@/components/tables/constructionProgramme/programme3.vue");
const trafficSimulation = () =>
  import("@/components/tables/fixedRoute/Index.vue");
const trafficSimulation_PTV = () =>
  import("@/components/tables/fixedRoute/PTV_trafficFlow.vue");
const mapSwiper = () => import("@/components/common/swiper/Index.vue");
const modelDetails = () => import("@/components/tables/modelDetails/Index.vue");
const ShpModal = () => import("@/components/tables/shpInfoList/Index.vue");
const toolLibrary = () => import("@/components/common/menu/ToolLibrary");
const viewpoint = () => import("@/components/tables/viewpoint/viewpoint.vue");
const modelSet = () => import("@/components/tables/modelSet/modelSet.vue");
const plotTree = () => import("@/components/tables/plotItem/plotTree.vue");
const evaluationIndex = () =>
  import("@/components/tables/evaluationIndex/evaluationIndex");
const BaotongScheme = () =>
  import("@/components/tables/BaotongScheme/BaotongScheme");
const Timeline = () => import("@/components/tables/Timeline/Timeline.vue");
const sectionInformation = () =>
  import("@/components/tables/sectionInformation/sectionInformation.vue");
const ptv = () => import("@/components/tables/ptv/Index.vue");
const newModelCut = () => import("@/components/tables/newModelCut/Index.vue");
const MapVideoPlay = () => import("@/components/common/mapVideoPlay/Index.vue");

const ConstructionSimulation = () =>
  import("@/components/tables/animation/constructionSimulation/List.vue");
const Animation = () => import("@/components/tables/animation/Index.vue");
const programmeSimulation = () =>
  import("@/components/tables/Timeline/programmeSimulation.vue");
import Program from "@/components/tables/program/Index.vue";
import * as indexedDbMap from "@/components/tables/indexedDb/map.js";

// import {mapGetters,} from 'vuex';
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { EventBus } from "../../static/js/event-bus.js";
import {
  getServeTerrainList,
  dynamicDigHole,
  judgeGlobalTerrain,
  serveTerrainList,
} from "@/mapUtils/TerrainUtils.js";
import _ from "lodash";
import {
  BimModel,
  ViewShed,
  BimElevationImage,
  BimTerrainProvider,
  BimVector,
} from "chbim";
// import BimVector from "./zhang";
import * as skyBox from "@/components/common/skyBox/map";
/* 引入Mars3d 的 Kml2JsonLayer.js代码 */
import Kml2JsonLayer from "../../static/js/mars3d/geojson/kml2json/Kml2JsonLayer.js";
//import * as mapWork from "./map.js";
import * as mapWork from "@/components/tables/program/map.js";
import {
  notSimplifyGeoJSON,
  lowSimplifyGeoJSON,
  mediumSimplifyGeoJSON,
  highSimplifyGeoJSON,
} from "@/components/tables/shpInfoList/map.js";
import {
  notSimplifyKmlGeoJSON,
  lowSimplifyKmlGeoJSON,
  mediumSimplifyKmlGeoJSON,
  highSimplifyKmlGeoJSON,
} from "@/components/tables/program/map.js";
export default {
  name: "Index",
  components: {
    bMap,
    MarkList,
    Measure,
    Transparency,
    BasicSkills,
    DrawLine,
    ModelCut,
    ProfileAnalysis,
    ModelCrop,
    RouteRoaming,
    CustomRoaming,
    VideoRoaming,
    StationQuery,
    routeInteraction,
    newRouteInteraction,
    lineElInfo,
    drawCrossSection,
    statisticsEarthwork,
    ThemeChoose,
    PropertyList,
    ModelTransparency,
    BasicSettings,
    LabelList,
    TerrainElevation,
    ContourLine,
    SunshineAnalysis,
    ModelFlattening,
    TerrainDigging,
    NewTerrainDigging,
    ModelRotation,
    ModelTranslation,
    ShpInfoList,
    ScenesSettings,
    SpecialEffects,
    ScenePlot,
    TerrainModify,
    BimVideo,
    BimVideoCategory2,
    BimMonitor,
    BimDemolition,
    BimEngineeringChange,
    newBimEngineeringChange,
    Program,
    PlanDemo,
    Vehicle,
    modelDetails,
    bimModelAttributes,
    programme1,
    programme2,
    programme3,
    trafficSimulation,
    ShpModal,
    toolLibrary,
    viewpoint,
    plotTree,
    evaluationIndex,
    BaotongScheme,
    Timeline,
    sectionInformation,
    modelSet,
    mapSwiper,
    ptv,
    newModelCut,
    HundredStake,
    MapVideoPlay,
    trafficSimulation_PTV,
    ConstructionSimulation,
    Animation,
    programmeSimulation,
  },
  watch: {
    filterText(val) {
      //防抖 0.7秒
      let that = this;
      clearTimeout(this.timer_input);
      this.timer_input = setTimeout(function () {
        that.$refs.tree.filter(val);
      }, 700);
    },
  },
  data() {
    let basePathUrl = window.basePathUrl || "";
    return {
      newTerrainDiggingData: null,
      isExpandList: [],
      configUrl: basePathUrl + "config/config.json",
      widgetUrl: basePathUrl + "config/widget.json",

      filterText: "",
      activeIndex: "",
      topMenuOpen: [],
      data: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      projectTreeShow: true,
      showAside: true,
      //loading: !this.$GLOBAL.loading_map_finish,
      loading: true, // 地图加载。
      loading2: true, // 开场动画加载。地图结束加载后会出现一小段时间的Cesium纯蓝色地球，为了使结束加载动画后，就出现影像，所以这里设置一个loading2。
      stopLoadingTimer2: null,
      //timer: "", //【用于取消地图加载动画】定时器
      timer_dom: "", //【用于设置Dom元素滚动条】定时器
      timer_input: "", //用于设置输入框防抖
      //time_limit: 300, //定时器每个多长时间执行一次，单位毫秒。
      //spendTime: 0, //判断定时器开始运行后的时间，如果超过一段时间后自动刷新页面。

      open_box: "", //当前打开的弹窗组件。最多只同时显示一个组件。
      program_box: "",

      show_pbtn: false, //如果账号只有一个项目可看则不可以看到那个跳往项目列表的按钮

      max_aside_length: 252, //最大左侧边栏宽度

      searchTree: "model", //左侧搜索栏展示内容。为'model'表示展示模型目录树【默认】，为'mbs'表示展示MBS标准目录树。

      propertyList_show: false, //是否展示模型属性列表

      isShowComponent: false, //是否展示模型构建属性列表

      modelTransparancyValue: 1, //模型地表透明度，默认为1

      currentLayerId: "", //当前选中的模型图层Id。

      // modelProList: '', //当前选中模型的属性列表

      checkedIds: [], //页面加载时默认勾选的id

      userAccount: "",

      bottomNavBtnIndex: 0, //顶部导航栏点击展开状态的按钮。

      menuData: null,

      loadingGif: require("@public/images/marsLoading.gif"),
      timerZ: null,
      offsetY: -418,
      fullName: null,
      terrainModificationData: [],
      programActiveIndex: null,
      // 环境透明参数
      transparentSwitch: true,
      transparentValue: 1,
      ifSwitchScenes: true,
      showimg: false,
      imgList: [],
      showVideo: false,
      videoList: [],
      articleString: null,
      modelTitle: null,
      modelTender: null,
      model: {
        elevationImage: false,
        model: false,
        terrain: false,
        shp: false,
        VideoSurveil: false,
        BimMonitor: false,
        BimDemolition: false,
        BimEngineeringChange: false,
        newBimEngineeringChange: false,
        programme1: false,
        programme2: false,
        programme3: false,
        trafficSimulation: false,
        viewpoint: false,
        plotTree: false,
        evaluationIndex: false,
        BaotongScheme: false,
        Timeline: false,
        sectionInformation: false,
        modelSet: false,
        ptv: false,
        newModelCut: false,
        hundredStake: false,
        stationQuery: false,
        routeInteraction: false,
        new_querystake: false,
        lineElInfo: false,
        drawCrossSection: false,
        statisticsEarthwork: false,
        trafficSimulation_PTV: false,
        constructionSimulation: false,
      },
      programmeSimulationShow: false,
      animation: {
        type: "2",
        selectTime: [],
        totalTime: "",
        company: "second",
        animationData: [],
        groups: [],
      },
      initCustomDate: "",
      maxTime: "",
      startBtnShow: true,
      loading: false,
      toolLibraryData: null,
      rElMenuData: [],
      bimModelArr: [],
      bimVector: false,
      isScreenshot: true,
      screenshotIndex: 0,
    };
  },
  created() {
    console.log("地图初始化");
    // 经纬度控制在8位精度
    mars3d.LngLatPoint.FormatAltLength = 2;
    mars3d.LngLatPoint.FormatLength = this.$GLOBAL.lngLatPointFormatLength;
    // 确保在子组件mounted()方法被调用前就获取到projectId的值。
    projectId = window.sessionStorage.getItem("nowProjectId");
    console.log(this.$route.params.stype, "路由参数");
    if (this.$route.params.stype == "program") {
      document.getElementsByTagName("body")[0].className =
        "program-status status-cover";
      $(".left-side-bar").addClass("hide");
    } else {
      console.log("沙盘");
      document.getElementsByTagName("body")[0].className = "";
    }
    // this.menuData = this.processMenu(menu, 0);
    this.initMenu();
    this.resetMenu();
  },
  mounted() {
    window.menuOperate = this.menuOperate;
    //获取标识字符串【现在仅用于对于查看Cesium原生效果】
    if (this.$route.params.stype.indexOf("program") > -1) {
      this.program_box = "Program";
    }
    idenStr = window.sessionStorage.getItem("idenStr");
    appScenarios = parseInt(window.sessionStorage.getItem("appScenarios"));
    if (![1, 2, 3, 4].includes(appScenarios)) {
      appScenarios = 1;
    }
    //alert(appScenarios)
    // console.log('begin:'+idenStr);
    //alert(idenStr)

    let loginAccount = window.sessionStorage.getItem("loginAccount");
    if (loginAccount) {
      this.userAccount = loginAccount;
    }

    EventBus.$on("updateLayerId", (param) => {
      console.log("是否切换了模型。", param);
      //return false;
      let changeLayer = false; //是否切换了模型。
      let preLayerId = this.currentLayerId;
      let tileLayer = this.$GLOBAL.map.getLayer(param.childId, "modelId");
      let preLayer = null;
      if (preLayerId) {
        preLayer = this.$GLOBAL.map.getLayerById(param.preLayerId);
        if (preLayer) {
          preLayer.closeHighlight();
        }
      }

      //如果切换了模型
      if (param.newLayerId !== this.currentLayerId) {
        changeLayer = true;
      }

      this.layerChanged = changeLayer;
      this.currentLayerId = param.newLayerId;
      window.sessionStorage.setItem("currentLayerId", this.currentLayerId);
      window.sessionStorage.setItem("childId", param.childId);

      //return false;
      if (this.$refs.tree) {
        this.$refs.tree.setCurrentKey(param.childId);
      }
      //return false;
      //let layerInfo = this.$store.dispatch('find_layer', param.newLayerId);
      let layerInfo = this.$store.getters.findLayerInfo(param.newLayerId);
      let layerInfoPA = Object.getOwnPropertyNames(layerInfo);

      let layerInfoTransparency = 1;
      //暂时注释掉下面这里的透明度赋值，是为了避免出现一个bug，就是单击的第一个构件其高亮和【继承模型的】透明度会持续保留。
      if (layerInfoPA.length > 0 && !param.pickedObject) {
        layerInfoTransparency = layerInfo.transparency;
      }
      // 读取内存中存放的当前选择模型的透明度。
      this.modelTransparancyValue = layerInfoTransparency;

      if (tileLayer) {
        if (changeLayer && this.$refs.tree) {
          //避免模型剖切导致模型隐藏的问题。
          //该选项还必须是被勾选状态才恢复显示。
          let checkedItems = this.$refs.tree.getCheckedNodes().map((item) => {
            return item.cesium3DTilesetIndex;
          });
          if (checkedItems && checkedItems.length > 0 && preLayerId) {
            let findTIndex = checkedItems.indexOf(preLayerId);
            if (findTIndex !== -1) {
              tileLayer.show = true;
            }
          }
        }

        if (param.pickedObject) {
          // tileLayer.closeHighlight();
          // tileLayer.openHighlight({
          // 	color: "rgba(255,0,0," + layerInfoTransparency + ")",
          // },true,param.pickedObject);

          tileLayer.openHighlight(
            {
              color: "rgba(255,0,0," + layerInfoTransparency + ")",
            },
            true,
            param.pickedObject
          );
        } else {
          if (tileLayer.style == undefined && tileLayer.opacity == 1) {
            tileLayer.openHighlight(
              {
                color: "rgba(255,0,0," + layerInfoTransparency + ")",
              },
              true
            );
          }
        }
      }

      //获取用户自定义配置。

      let transparency = JSON.parse(
        localStorage.getItem("basicSettings")
      ).transparency;
      let property = JSON.parse(localStorage.getItem("basicSettings")).property;
      let isShowComponent = JSON.parse(
        localStorage.getItem("basicSettings")
      ).isShowComponent;
      this.isShowComponent = isShowComponent;

      // if (typeof(transparency) === 'undefined' || transparency === 'true') {
      if (transparency) {
        this.open_box = "ModelTransparency";
      }
      // if (typeof(property) === 'undefined' || property === 'true') {
      if (property) {
        console.log("param", param.title);
        this.propertyList_show = true;
        this.modelTitle = param.title;
        this.modelTender = param.tender;
        // getBimModelAttributesList({
        //   projectId: window.sessionStorage.getItem("nowProjectId"),
        //   fullName: param.title,
        // })
        //   .then((res) => {
        //     console.log(res);
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      }

      // 获取模型属性列表信息并展示。
      //this.getModelProperty();
      //this.propertyList_show = true;
      if (this.$refs.ModelTransparency) {
        this.$refs.ModelTransparency.initData(this.modelTransparancyValue);
      }
    });

    const projectInfoArr = JSON.parse(
      sessionStorage.getItem("projectInfoArrJson")
    );
    //let id = this.$route.query.id;
    //这里可以验证该projectId项目此账号是否有权限查看，及对projectId字符串进行正则判断。注意提交给后台验证前对字符串进行转义处理，避免xss攻击等。

    // if (projectInfoArr && projectInfoArr.length > 0) {
    // 让 单项目账号 电子沙盘主界面能够出现项目列表页按钮。
    //if (projectInfoArr.length > 1) {
    this.show_pbtn = true;
    if (!projectId) {
      this.$alert("参数缺失，请重新进入当前页面。", "错误提示", {
        confirmButtonText: "确定",
        type: "error",
        callback: (action) => {
          this.$router.push({
            path: "/projectsList",
          });
        },
      });
    }
    // } else {
    // this.$alert("数据出错啦，请重新登录。111", "错误提示", {
    //   confirmButtonText: "确定",
    //   type: "error",
    //   callback: (action) => {
    //     this.$router.push({
    //       path: "/login",
    //     });
    //   },
    // });
    // }
    let currentLayerId = window.sessionStorage.getItem("currentLayerId");
    if (currentLayerId) {
      this.currentLayerId = currentLayerId;
    }

    // this.timer = setInterval(this.timerClear, this.time_limit);
    this.timer_dom = setInterval(this.timerClear_dom, 400);

    //监听鼠标滚动事件
    //window.addEventListener('mars3d.EventType.wheel', this.debounce(this.handleScroll, 300), true) || window.addEventListener("DOMMouseScroll", this.debounce(this.handleScroll, 300), false)
    //window.addEventListener('mars3d.EventType.wheel', this.debounce(this.handleScroll, 300), true);

    //鼠标拉缩侧边栏宽度。
    this.dragControllerDiv();

    //进入页面时禁用浏览器自带的右键弹窗功能，避免影响到本程序里地图右键功能的良好展示。
    window.oncontextmenu = function () {
      return false;
    };
    console.log(process.env);

    if (this.$route.params.stype == "sandbox_traffic") {
      setTimeout(() => {
        this.model.Timeline = true;
      }, 500);
    }
    this.initIndexDb();
  },
  computed: {
    ...mapState(["count"]),
  },
  methods: {
    menuOperate(e, list, htmlText) {
      // console.log("menuOperate", e);
      const type = e.currentTarget.dataset.type;
      list.forEach((item) => {
        item.src = item.id;
        item.text = item.remarks;
      });
      if (type == "image") {
        this.imgList = list;
        this.articleString = htmlText;
        this.showimg = true;
      }
      if (type == "play") {
        this.videoList = list;
        this.showVideo = true;
      }
    },
    // 打开地形开挖界面
    openNewTerrainDigging() {
      this.open_box = "NewTerrainDigging";
      this.offsetY = -600;
    },
    resetMenu() {
      this.$eventBus.$on("resetMenu", (res) => {
        this.initMenu();
      });
    },
    initMenu() {
      // console.log("菜单数据");

      // index.js 只加载沙盘类型的菜单
      if (this.$route.params.stype.indexOf("sandbox") > -1) {
        menuChange({
          application: this.$route.params.stype,
          projectId: window.sessionStorage.getItem("nowProjectId"),
        })
          .then((resL) => {
            if (resL.data.success && resL.data.data) {
              let menuData = [],
                rMenuData = [];

              this.processMenu(resL.data.data, 0).forEach((item) => {
                if (item.meta.position == 0) {
                  menuData.push(item);
                } else if (item.meta.position == 1) {
                  if (item.remark == "toolLibrary") {
                    this.toolLibraryData = item;
                  } else {
                    rMenuData.push(item);
                  }
                }
              });

              this.menuData = JSON.parse(JSON.stringify(menuData));
              this.rElMenuData = JSON.parse(JSON.stringify(rMenuData));

              console.log(
                "/******************************************************************"
              );
              console.log(JSON.parse(JSON.stringify(this.menuData)));
              if (this.$route.params.stype == "sandbox_traffic") {
                // 交组仿真 区分全局和工点菜单

                if (
                  window.sessionStorage.getItem("cross_group_type") == "global"
                ) {
                  for (let i = 0; i < this.menuData.length; i++) {
                    if (
                      this.menuData[i].remark == "trafficSimulation" ||
                      this.menuData[i].remark == "trafficSimulation_PTV" ||
                      this.menuData[i].remark == "modelSet" ||
                      this.menuData[i].remark == "programme3"
                    ) {
                      this.menuData.splice(i, 1);
                      i--;
                    }
                  }
                } else if (
                  window.sessionStorage.getItem("cross_group_type") == "working"
                ) {
                  for (let i = 0; i < this.menuData.length; i++) {
                    if (
                      this.menuData[i].remark == "evaluationIndex" ||
                      this.menuData[i].remark == "BaotongScheme"
                    ) {
                      this.menuData.splice(i, 1);
                      i--;
                    }
                  }
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    processMenu(data, root, idTxt, pidTxt, pushTxt) {
      var idTxt = idTxt || "id";
      var pidTxt = pidTxt || "pid";
      var pushTxt = pushTxt || "children"; // 递归方法
      function getNode(id) {
        var node = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i][pidTxt] == id) {
            let tdata = getNode(data[i][idTxt]);
            if (!tdata) {
              tdata = [];
            }
            data[i][pushTxt] = tdata;
            node.push(data[i]);
          }
        }
        if (node.length == 0) {
          return;
        } else {
          return node;
        }
      } // 使用根节点
      return getNode(root);
    },

    modalManagement({ remark, meta }) {
      // console.log("点击的", remark);
      if (remark && remark != "" && remark != undefined) {
        this.open_box = remark;
      } else {
        this.popUps(meta.title);
      }
    },
    reset() {
      this.$GLOBAL.map.basemap = null;
      let mapSplit;
      if (this.$GLOBAL.map.controls.mapSplit) {
        mapSplit = this.$GLOBAL.map.controls.mapSplit;
        mapSplit.destroy();
      } else {
        mapSplit = new mars3d.control.MapSplit({
          leftLayer: [
            { name: "天地图电子", type: "tdt", layer: "vec_d" },
            { name: "天地图注记", type: "tdt", layer: "vec_z" },
          ],
        });
        this.$GLOBAL.map.addControl(mapSplit);
      }
    },

    // 地图构造完成回调
    onMapload(map, mapObj) {
      console.log("地图加载完成");
      // 初始化平台设置,接收地图,不传默认为$GLOBAL.map
      this.getModelTree();

      //加载国界十段线
      this.showNationalBoundaries();
      this.recursionProjectGisInfo(mapObj.get("gis"));
      this.bimVector = true;
      this.loading2 = false;
    },

    onMapload3(map) {
      console.log("地图加载完了", this.$GLOBAL.map);
      //webgl渲染失败后，刷新页面
      map.on(mars3d.EventType.renderError, function (event) {
        console.log(event);
        that.$message({
          message:
            "当前系统运行出现异常，可能是勾选的模型过多导致的，请刷新当前页面~",
          type: "warning",
          offset: 100,
          showClose: true,
          duration: 3600,
        });
      });

      // 缩放工具
      var zoom = new mars3d.control.Zoom({
        insertIndex: 1, //插入的位置顺序
        zoomInClass: "fa fa-plus",
        zoomOutClass: "fa fa-minus",
      });
      map.addControl(zoom);

      getProjectGisInfo({
        projectId: projectId,
      }).then(function (res) {
        // console.log(res.data.data);
        // console.log(2222222);
        let PGIData = res.data.data;
        that.recursionProjectGisInfo(PGIData);
        //加载国界十段线
        that.showNationalBoundaries();
      });
      // console.log(3333);

      //获取 模型目录树列表 并添加到map里。
      this.getModelTree();

      // 加载文本标注KML文件。
      getKmlInfo({
        projectId: sessionStorage.getItem("nowProjectId"),
      }).then(function (res) {
        // console.log(KmlData);
        // that.recursionKmlInfo(KmlData);
        that.treeData = that.$GLOBAL.labelListTree;
        // console.log(JSON.parse(JSON.stringify(that.$GLOBAL.labelListTree)));
        // console.log('0000000000000000000');
      });

      //显示底部信息栏
      const locationBar = new mars3d.control.LocationBar({
        fps: false,
        template:
          "<div>经度：{lng}</div><div>纬度：{lat}</div> <div>海拔：{alt}米</div> <div>层级：{level}</div><div>方向：{heading}度</div> <div>俯仰角：{pitch}度</div><div>视高：{cameraHeight}米</div>",
      });
      map.addControl(locationBar);
      try {
        // 刷新报错
        //}, 1000);

        // //默认鼠标拖拽不可进入地下。 效果不好故舍弃。
        // let canSeeUnderground=window.localStorage.getItem('settings_canSeeUnderground');
        // // const options = { cameraController: {},highDynamicRange:true }
        // // if(canSeeUnderground==='true'){
        // // 	//alert(1)
        // // 	options.cameraController['enableCollisionDetection'] = true;
        // // }else{
        // // 	//alert(2)
        // // 	options.cameraController['enableCollisionDetection'] = false;
        // // }
        // // that.$GLOBAL.map.setSceneOptions(options);
        // if(canSeeUnderground==='true'){
        // 	if(that.$GLOBAL.map.scene.cameraController){
        // 		that.$GLOBAL.map.scene.cameraController.enableCollisionDetection = true;
        // 	}else{
        // 		that.$GLOBAL.map.scene.cameraController={enableCollisionDetection:true};
        // 	}

        // }else{
        // 	if(that.$GLOBAL.map.scene.cameraController){
        // 		that.$GLOBAL.map.scene.cameraController.enableCollisionDetection = false;
        // 	}else{
        // 		that.$GLOBAL.map.scene.cameraController={enableCollisionDetection:false};
        // 	}
        // }

        const toolButton1 = new mars3d.control.ToolButton({
          title: "初始视图",
          icon: "/img/icon/home_icon.svg",
          insertIndex: 3, // 插入的位置顺序
          click: () => {
            //alert("触发回调~")
            // this.$GLOBAL.map.viewer.destroy();
            that.initialViewingAngle();

            //移除地图里已添加的模型，并重新添加，起到清理一下内存空间的效果【在一定视角高度下模型不加载】。
            // console.log(JSON.parse(JSON.stringify(that.data)));
            // console.log('0100000000000000');
            that.recursionClear(that.data, that);
            that.data = [];
            that.checkedIds = [];
            that.getModelTree();
          },
        });
        this.$GLOBAL.map.addControl(toolButton1);

        let toolButton2, toolButton2_2;
        toolButton2 = new mars3d.control.ToolButton({
          title: "全屏",
          icon: "/img/icon/arrow-bigger.svg",
          insertIndex: 5, // 插入的位置顺序
          click: () => {
            //进入全屏
            let element = document.documentElement;
            if (element.requestFullscreen) {
              element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
              element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
              element.msRequestFullscreen();
            }
            that.$GLOBAL.map.removeControl(toolButton2);
            that.$GLOBAL.map.addControl(toolButton2_2);
          },
        });
        toolButton2_2 = new mars3d.control.ToolButton({
          title: "退出全屏",
          icon: "/img/icon/exit-full-screen.svg",
          insertIndex: 5, // 插入的位置顺序
          click: () => {
            //退出全屏
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
              document.webkitExitFullscreen();
            }
            that.$GLOBAL.map.removeControl(toolButton2_2);
            that.$GLOBAL.map.addControl(toolButton2);
          },
        });
        this.$GLOBAL.map.addControl(toolButton2);

        const toolButton3 = new mars3d.control.ToolButton({
          title: "进入VR模式",
          icon: "/img/icon/vr-glasses.svg",
          insertIndex: 6, // 插入的位置顺序
          click: () => {
            //alert(3)
            // 这句话打开VR
            that.$GLOBAL.map.scene.useWebVR = true;

            // WebVR相关参数: 眼镜的视角距离（单位：米）
            that.$GLOBAL.map.scene.eyeSeparation = 100.0;

            // WebVR相关参数: 焦距
            that.$GLOBAL.map.scene.focalLength = 5.0;

            that.$message({
              message:
                "请先佩戴3D眼镜，并且将您的显示器调整为3D模式，才能看到效果哦。",
              type: "success",
              offset: 100,
              showClose: true,
              duration: 3600,
            });

            that.$GLOBAL.map.removeControl(toolButton3);
            that.$GLOBAL.map.addControl(toolButton3_2);
          },
        });
        const toolButton3_2 = new mars3d.control.ToolButton({
          title: "退出VR模式",
          icon: "/img/icon/exit-vr.svg",
          insertIndex: 6, // 插入的位置顺序
          click: () => {
            //alert(3)
            that.$GLOBAL.map.scene.useWebVR = false;
            that.$GLOBAL.map.removeControl(toolButton3_2);
            that.$GLOBAL.map.addControl(toolButton3);
          },
        });
        this.$GLOBAL.map.addControl(toolButton3);

        // console.log('定位:'+idenStr);
        if (idenStr) {
          // alert(1)
          // 定位到一座桥上的一个点。
          this.$GLOBAL.map.setCameraView({
            lng: 107.703231,
            lat: 26.164987,
            alt: 829.8,
          });
        }

        //判断地图是否加载完成 设置的一段代码。
        let helper = new Cesium.EventHelper();

        helper.add(map.viewer.scene.globe.tileLoadProgressEvent, (e) => {
          //console.log('每次加载地图服务矢量切片都会进入这个回调',e);
          that.$GLOBAL.loading_map_times++;
          // if (e== 0) {
          // 	console.log("这个是加载最后一个矢量切片的回调【好像失效了？】");
          // 放宽限制来判断，只要加载了五个矢量切片就认为同样可以取消加载动画了。
          //if (e == 0 || that.$GLOBAL.loading_map_times > 4) {
          if (e == 0 || that.$GLOBAL.loading_map_times > 4) {
            helper.removeAll();
            that.loading = false; //此时就结束地图加载。
            that.initialViewingAngle();
          }
        });
        this.stopLoadingTimer2 = setTimeout(() => {
          // 如果 20秒后还没有结束加载动画，那么就停止加载动画，避免因为地图监听事件出问题了，导致一直呈现加载动画。
          if (that.loading) {
            that.loading = false;
            that.loading2 = false;
            clearTimeout(this.stopLoadingTimer2);
            this.stopLoadingTimer2 = null;
          }
        }, 20000);
      } catch (err) {
        console.log(err);
      }

      // 初始化平台设置,接收地图,不传默认为$GLOBAL.map
      initPlatformSettings();
    },
    // 获取最新全部挖洞数据
    getTerrainList() {
      judgeGlobalTerrain();
      getServeTerrainList((e) => {
        viewShed.resourceRelease(this.data);
        viewShed.on("enter", (e) => {
          this.enter(e);
          dynamicDigHole.call(
            this,
            true,
            this.getDynamicDiggingData(e.uid, e.modelId, e.cesium3DTilesetIndex)
          );
        });
        viewShed.on("leave", (e) => {
          this.leave(e);
          dynamicDigHole.call(
            this,
            false,
            this.getDynamicDiggingData(e.uid, e.modelId, e.cesium3DTilesetIndex)
          );
        });
      });
    },
    getModelTree() {
      // 不在方案里面使用
      let that = this;
      //获取 模型目录树列表 并添加到map里。
      let modelData = {
        ProjectId: projectId,
        CategoryName: "子分项工程",
      };
      getProjectBimModel(modelData).then((res) => {
        //对数据进行处理，添加线位
        // 想展开二级就传一级ID 三级就传二级ID 以此类推
        let { dataList, isExpandList } = res.data.data;
        this.isExpandList = isExpandList;
        // viewShed.initial(this.enter);
        this.$GLOBAL.ptDataList = dataList;
        if (this.$route.params.stype.indexOf("program") < 0) {
          this.recursion(dataList);
          that.data = dataList;
          that.checkedIds = that.$GLOBAL.checkedIds;
          this.getTerrainList();
        }
        panoramicView.on("intercept", (e) => {
          this.isScreenshot = false;
          this.screenshotIndex = e.index;
          // this.$notify({
          //   title: "截图完成，请继续",
          //   message: "",
          //   type: "success",
          //   duration: 960,
          //   offset: 320,
          // });
        });
      });
    },

    screenshot() {
      if (panoramicView) {
        this.isScreenshot = true;
        panoramicView.screenshot(this.screenshotIndex);
      }
    },

    getDynamicDiggingData(uid, modelId, cesium3DTilesetIndex) {
      let obj = {
        modelId: modelId,
        uid: uid,
        cesium3DTilesetIndex: cesium3DTilesetIndex,
        bimModelExcavationDetails: [],
      };
      serveTerrainList.forEach((item) => {
        if (item.embsId == modelId) {
          obj.bimModelExcavationDetails.push(item);
        }
      });
      return obj;
    },

    enter(e) {
      if (e.permission) {
        this.createTilesetLayerNew(e, "resourceRelease", (event) => {
          this.findPnodeId(this.data, e.modelId).cesium3DTilesetIndex =
            event.layer.id;
          e.uid = event.layer.id;
        });
      }
    },
    leave(e) {
      if (e.permission) {
        this.$GLOBAL.map.removeLayer(e.uid, true);
      }
    },
    //将列表数据转为树结构数据。
    getTree(data, root, idTxt, pidTxt, pushTxt) {
      var idTxt = idTxt || "id";
      var pidTxt = pidTxt || "pid";
      var pushTxt = pushTxt || "children";
      // 递归方法
      function getNode(id) {
        var node = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i][pidTxt] == id) {
            let tdata = getNode(data[i][idTxt]);
            if (!tdata) {
              tdata = [];
            }
            data[i][pushTxt] = tdata;
            node.push(data[i]);
          }
        }
        if (node.length == 0) {
          return;
        } else {
          return node;
        }
      }
      // 使用根节点
      return getNode(root);
    },
    //递归处理模型树数据
    recursion(data) {
      data.forEach((item) => {
        // console.log("单选数据", item.title, item.bimModel.isDisplay, item);
        if (item.children.length > 0) {
          this.recursion(item.children);
        } else {
          //没有子项时做的操作
          if (!item.bimModel.type) {
            if (item.bimModel.version === "wms") {
              //为线位
              // console.log(item);

              if (item.bimModel.isDisplay) {
                this.$GLOBAL.checkedIds.push(item.id);
                //展示数据
                let wmsProvider = new mars3d.layer.WmsLayer({
                  //url: 'http://bim-dev:8080/geoserver/WuYuProjects/wms',
                  //layers: layers[i],
                  url: item.bimModel.modelUrl,
                  layers: item.bimModel.modelName,
                  parameters: {
                    transparent: true, //是否透明
                    format: "image/png", //application/openlayers
                    srs: "EPSG:4326",
                    styles: "",
                  },
                  show: true,
                  hasZIndex: true,
                  zIndex: item.bimModel.order || 100,
                });
                this.$GLOBAL.map.addLayer(wmsProvider);
                item.imageryLayer = wmsProvider.id;
              }
            } else {
              //为模型

              if (item.bimModel.isDisplay) {
                //展示数据
                // this.bimModelArr.push(item);
                item.modelUrl =
                  this.$GLOBAL.projectBaseUrl +
                  this.$GLOBAL.modelBasePort +
                  item.bimModel.modelUrl;

                window.bimModel.pushModel(item);
                this.$GLOBAL.checkedIds.push(item.id);
                item.cesium3DTilesetIndex = "init";
                // this.createTilesetLayerNew(item, "init", (e) => {
                //   item.cesium3DTilesetIndex = e.layer.id;
                // });
                // 避免Cesium原生加载模型代码报错。
                // if (!idenStr) {
                //   item.cesium3DTilesetIndex = tilesetLayer.id;
                // }
              }
            }
          } else {
            //为目录
          }
        }
      });
    },
    //用于回归初始视角时递归清理已加载的线位和模型，释放内存占用。
    recursionClear(data, that) {
      //alert(1);
      // return false;
      data.forEach((item) => {
        if (item.children.length > 0) {
          that.recursionClear(item.children, that);
        } else {
          //没有子项时做的操作
          if (!item.bimModel.type) {
            if (item.bimModel.version === "wms") {
              //为线位
              if (item.imageryLayer) {
                // console.log('wms:');
                // console.log(item.imageryLayer);
                let layer = that.$GLOBAL.map.getLayerById(item.imageryLayer);
                if (layer) {
                  that.$GLOBAL.map.removeLayer(layer, true); //移除layer。
                }
                item.imageryLayer = 0;
              }
            } else {
              //为模型
              if (item.cesium3DTilesetIndex) {
                // console.log('model:');
                // console.log(item.cesium3DTilesetIndex);
                let cesium3DTileset = that.$GLOBAL.map.getLayerById(
                  item.cesium3DTilesetIndex
                );
                if (cesium3DTileset) {
                  that.$GLOBAL.map.removeLayer(cesium3DTileset, true); //先移除旧的layer。
                }
                //如果勾选项含当前选中项，则取消当前选中项的高亮【因为可以通过勾选父节点一次勾选多个模型，此举为避免混乱】。
                if (that.currentLayerId === item.cesium3DTilesetIndex) {
                  window.sessionStorage.removeItem("currentLayerId");
                  that.currentLayerId = "";
                  if (cesium3DTileset) {
                    cesium3DTileset.closeHighlight();
                  }
                  if (that.$refs.tree) {
                    that.$refs.tree.setCurrentKey(null);
                  }
                }
                item.cesium3DTilesetIndex = 0;
              }
            }
          } else {
            //为目录
          }
        }
      });
    },
    showNationalBoundaries() {
      let url = this.$GLOBAL.localResourcesPath + "Upload/Json/国界.json";
      let graphicLayer = new mars3d.layer.GeoJsonLayer({
        name: "国界",
        //url: "/baseIP/Upload/Json/国界.json",
        url: url,
        format: highSimplifyGeoJSON,
        symbol: {
          type: "polylineC",
          styleOptions: {
            width: 2,
            materialType: "Color",
            materialOptions: {
              color: "#CD9B1D",
            },
            distanceDisplayCondition: true,
            distanceDisplayCondition_near: 1000,
            distanceDisplayCondition_far: 20000000,
            clampToGround: true,
            classificationType: Cesium.ClassificationType.TERRAIN,
          },
        },
      });
      this.$GLOBAL.map.addLayer(graphicLayer);
    },
    //递归处理 GIS信息服务 获取GisModify树列表
    recursionProjectGisInfo(data) {
      data.forEach((item) => {
        //this.$GLOBAL.checkedIds.push(item.id);
        if (item.children.length > 0) {
          this.recursionProjectGisInfo(item.children);
          //如果有子元素，且该项为地形的父节点，那么添加disabled:true
          if (item.gisInfo.gisType === 1 && item.gisInfo.type) {
            item.disabled = true;
          }
        } else {
          //没有子项时做的操作
          if (!item.gisInfo.type && item.gisInfo.gisUrl != null) {
            if (item.gisInfo.gisType === 0) {
              //为影像
              let url =
                this.$GLOBAL.projectBaseUrl +
                this.$GLOBAL.domBasePort +
                item.gisInfo.gisUrl;
              if (item.gisInfo.isDisplay) {
                console.log("影像数据", url);
                if (!idenStr) {
                  item.url = url;
                  bimElevationImage.pushVector(item);
                } else {
                  let tileLayer = new Cesium.UrlTemplateImageryProvider({
                    url: url,
                  });
                  this.$GLOBAL.map.viewer.imageryLayers.addImageryProvider(
                    tileLayer
                  );
                }
              }
            } else if (item.gisInfo.gisType === 1) {
              // 为地形高程
              let url =
                this.$GLOBAL.projectBaseUrl +
                this.$GLOBAL.demBasePort +
                item.gisInfo.gisUrl;
              if (item.gisInfo.isDisplay) {
                // 测试Cesium原生加载地形效果。
                if (!idenStr) {
                  item.url = url;
                  //this.$GLOBAL.map.terrainProvider返回结果里没有uid，因此这里生成一个随机id，方便和目录树选项对应更新勾选状态。
                  let uid = Number(
                    Math.random().toString().substr(2, 26) + Date.now()
                  ).toString(36);
                  item.terrainId = uid;
                  //控制开启或关闭高程。
                  //this.$GLOBAL.map.hasTerrain=val;
                }
              }
            }
          } else {
            //为目录
          }
        }
      });
      // console.log("????????????", data);
      this.$GLOBAL.terrainElevationTree = data;
      //return data;
    },
    //递归处理 Shp数据信息服务 获取ShpInfo树列表
    recursionProjectShpInfo(data) {
      //alert(1);
      data.forEach((item) => {
        //this.$GLOBAL.checkedIds.push(item.id);
        if (item.children.length > 0) {
          this.recursionProjectShpInfo(item.children);
        } else {
          //没有子项时做的操作
          if (!item.shpInfo.type) {
            //为了让地图出现得更快，所以这里暂时设置默认不加载shpInfo信息。

            if (item.shpInfo.isDisplay) {
              let simplifyFunc = notSimplifyGeoJSON;
              if (
                item.shpInfo?.isOptimization != undefined &&
                !item.shpInfo?.isOptimization
              ) {
                simplifyFunc = notSimplifyGeoJSON;
              } else {
                switch (item.shpInfo?.optimizationDegree) {
                  case "low":
                    simplifyFunc = lowSimplifyGeoJSON;
                    break;
                  case "medium":
                    simplifyFunc = mediumSimplifyGeoJSON;
                    break;
                  case "high":
                    simplifyFunc = highSimplifyGeoJSON;
                    break;
                  default:
                    simplifyFunc = notSimplifyGeoJSON;
                    break;
                }
              }
              if (item.shpInfo.shpUrl) {
                //alert(item.title + " " + item.shpInfo.isDisplay);
                let url = this.$GLOBAL.localResourcesPath + item.shpInfo.shpUrl;
                //展示数据
                let geoJsonLayer = new mars3d.layer.GeoJsonLayer({
                  name: item.title,
                  //url: "/baseIP/" + item.shpInfo.shpUrl,
                  url: url,
                  format: simplifyFunc,
                  symbol: {
                    //type:"polygon",
                    styleOptions: {
                      fill: true,
                      //randomColor: true, //随机色
                      color: item.shpInfo.shpColor,
                      background: item.shpInfo.shpColor,
                      opacity: 1,
                      outline: true,
                      outlineStyle: {
                        //color: item.shpInfo.shpColor,
                        color: "#ffffff",
                        width: 3,
                        opacity: 1,
                      },
                      //高亮时的样式
                      highlight: {
                        opacity: 1,
                      },
                      label: {
                        //面中心点，显示文字的配置
                        text: "{NAME}", //对应的属性名称
                        //text: item.shpInfo.shpName, //对应的属性名称

                        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                        pixelOffsetY: -12,

                        opacity: 1,
                        font_size: item.shpInfo.shpTextSize || 26,
                        color: "#ffffff",

                        font_family: "黑体",
                        outline: true,
                        outlineColor: "#000000",
                        outlineWidth: 3,
                        font_weight: "normal",
                        font_style: "normal",

                        scaleByDistance: true,
                        scaleByDistance_far: 1000000,
                        scaleByDistance_farValue: 0.1,
                        scaleByDistance_near: 1000,
                        scaleByDistance_nearValue: 1,

                        distanceDisplayCondition: true,
                        distanceDisplayCondition_far:
                          item.shpInfo.shpDistinct || 50000,
                        distanceDisplayCondition_near: 0,
                        //visibleDepth: false, //避免文字被遮挡
                        clampToGround: true, //贴地
                        classificationType: Cesium.ClassificationType.TERRAIN, // 避免贴地时贴到模型上。
                      },
                      // polygon: {
                      //   distanceDisplayCondition: true,
                      //   distanceDisplayCondition_far: item.shpInfo.shpDistinct,
                      //   distanceDisplayCondition_near: 0,
                      //   visibleDepth: false, //避免文字被遮挡
                      //   clampToGround: true, //贴地
                      // },
                      distanceDisplayCondition: true,
                      distanceDisplayCondition_far:
                        item.shpInfo.shpDistinct || 50000,
                      distanceDisplayCondition_near: 0,
                      //visibleDepth: false, //避免文字被遮挡
                      clampToGround: true, //贴地
                      classificationType: Cesium.ClassificationType.TERRAIN, // 避免贴地时贴到模型上。
                    },
                  },
                  show: true,
                  popup: "{NAME}",
                  // popup: item.shpInfo.shpName,
                  // "tooltip": "{name}",
                  // flyTo: true,
                  hasZIndex: true, //是否可以调整图层顺序（在同类型图层间）
                  zIndex: item.shpInfo.order, //图层顺序，数字大的在上面。（当hasZIndex为true时）
                });
                this.$GLOBAL.map.addLayer(geoJsonLayer);
                item.geoJsonLayerId = geoJsonLayer.id;
              }
            }
          } else {
            //为目录
          }
        }
      });
      this.$GLOBAL.shpInfoListTree = data;
      // console.log(this.$GLOBAL.shpInfoListTree);
      // console.log(33333333333333);
      //return data;
    },
    //递归处理 文本标注 KML文件加载。
    recursionKmlInfo(data, needCreate = true) {
      data.forEach((item) => {
        //this.$GLOBAL.checkedIds.push(item.id);
        if (item.children.length > 0) {
          this.recursionKmlInfo(item.children, needCreate);
        } else {
          //没有子项时做的操作
          if (!item.kmlInfo.type) {
            if (item.kmlInfo.isDisplay) {
              this.checkedIds.push(item.id);
              if (needCreate) {
                if (item.kmlInfo.kmlUrl) {
                  this.createKmlLayer(item);
                }
              }
            }
          } else {
            //为目录
          }
        }
      });
      const list = [];
      data.forEach((item) => {
        if (item.children.length > 0) {
          item.children.forEach((etem) => {
            list.push(etem);
          });
        }
      });

      this.$GLOBAL.labelListTree = list;
    },
    createKmlLayer(item) {
      console.log("textDistinct", item.kmlInfo.textDistinct);
      let url = this.$GLOBAL.localResourcesPath + item.kmlInfo.kmlUrl;
      let simplifyFunc = notSimplifyKmlGeoJSON;
      if (
        item.kmlInfo?.isOptimization != undefined &&
        !item.kmlInfo?.isOptimization
      ) {
        simplifyFunc = notSimplifyKmlGeoJSON;
      } else {
        switch (item.kmlInfo?.optimizationDegree) {
          case "low":
            simplifyFunc = lowSimplifyKmlGeoJSON;
            break;
          case "medium":
            simplifyFunc = mediumSimplifyKmlGeoJSON;
            break;
          case "high":
            simplifyFunc = highSimplifyKmlGeoJSON;
            break;
          default:
            simplifyFunc = notSimplifyKmlGeoJSON;
            break;
        }
      }
      let kmlLayer = new mars3d.layer.Kml2JsonLayer({
        //url: "/baseIP/" + item.kmlInfo.kmlUrl,
        url: url,
        format: simplifyFunc,
        symbol: function (attr, style, featue) {
          return {
            fill: item.kmlInfo.fill,
            color: item.kmlInfo.textColor,
            opacity: 0.5,
            outline: true,
            outlineColor: "#ffffff",
            outlineWidth: 3,
            width: 3,
            // arcType: Cesium.ArcType.GEODESIC,
            // 标记文字
            clampToGround: true,
            //visibleDepth: false,
            distanceDisplayCondition: true,
            distanceDisplayCondition_far: item.kmlInfo.textDistinct || 6000,
            distanceDisplayCondition_near: 0,
            label: {
              text: "{name}",
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              pixelOffsetY: -10,

              opacity: 1,
              font_size: item.kmlInfo.textSize || 26,
              color: item.kmlInfo.textColor || "#ffffff",

              font_family: "黑体",
              outline: true,
              outlineColor: item.kmlInfo.sideColor || "#000000",
              outlineWidth: 3,

              scaleByDistance: true,
              scaleByDistance_far: 10000,
              scaleByDistance_farValue: 0.1,
              scaleByDistance_near: 20,
              scaleByDistance_nearValue: 1,
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
                0.0,
                item.kmlInfo.textDistinct || 20000
              ),
              clampToGround: true, //贴地
              // visibleDepth: false,
            },
            // polygon: {
            //   distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            //     0.0,
            //     item.kmlInfo.textDistinct || 20000
            //   ),
            //   visibleDepth: false,
            //   clampToGround: false, //不贴地
            // },
          };
        },
        // center: { lat: 31.653222, lng: 117.273592, alt: 35183, heading: 358, pitch: -63 },
        popup: "all",
        // flyTo: true
        clampToGround: true, //是否贴地
        // visibleDepth: false, //避免文字被遮挡
        show: true,
        // // "tooltip": "{name}",
        hasZIndex: true, //是否可以调整图层顺序（在同类型图层间）
        zIndex: item.kmlInfo.order, //图层顺序，数字大的在上面。（当hasZIndex为true时）
      });

      this.$GLOBAL.map.addLayer(kmlLayer);
      item.kmlLayerId = kmlLayer.id;
    },
    //递归处理 地形修改数据服务 获取GisModify树列表
    recursionProjectGisModify(data, that, terrainClip) {
      // console.log(terrainClip);
      // console.log('00000000000000');
      data.forEach((item) => {
        //this.$GLOBAL.checkedIds.unshift(item.id);
        if (item.children.length > 0) {
          this.recursionProjectGisModify(item.children, that, terrainClip);
        } else {
          //没有子项时做的操作
          if (!item.gisModify.type) {
            //暂时关闭页面加载时地形修改的显示。
            //item.gisModify.isDisplay = false;
            if (item.gisModify.isDisplay) {
              //展示数据。
              //使用getJSON读取userinfo.json文件中的数据。
              if (item.gisModify.modifyUrl) {
                //如果存在地形修改json数据文件链接。
                //let fileUrl = "/baseIP/" + item.gisModify.modifyUrl;
                let fileUrl =
                  this.$GLOBAL.localResourcesPath + item.gisModify.modifyUrl;
                let dataArr = [];
                //异步了。
                $.getJSON(fileUrl, function (data) {
                  // console.log(data);
                  // console.log(item.gisModify.modifyName);
                  // console.log(999999999);
                  for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < data[i].terrainModifier.length; j++) {
                      dataArr.unshift(
                        JSON.parse(data[i].terrainModifier[j].point)
                      );
                    }
                  }
                  if (item.gisModify.modifyType === 0) {
                    //挖洞。为了方便根据目录树的勾选来生成和清理挖洞区域，因此这里每个挖洞区域单独提供一个挖洞工具，并将挖洞工具的id保存到树结构数据中。
                    // console.log(dataArr.length);
                    // console.log(10111111111111111);
                    //let dataArrLength=dataArr.length;
                    //加了这个if判断程序容易崩溃。
                    //if(dataArrLength>=3){
                    let tempObj = terrainClip.addArea(dataArr, {
                      diffHeight: item.gisModify.depth,
                    });
                    item.uid = terrainClip.id; //terrainClip id
                    item.areaid = tempObj.id; //挖地区域id
                    //方便定位。
                    //item.positions = tempObj.positions.slice(0, 4);
                    //item.positions = tempObj.positions;

                    //}
                  } else if (item.gisModify.modifyType === 1) {
                    //压平。
                    //alert(1)
                  }
                });
              }
            }
          } else {
            //为目录
          }
        }
      });
      // this.$GLOBAL.terrainModifyTree = data;
      // console.log(this.$GLOBAL.terrainModifyTree);
      // console.log(33333333333333);
      //return data;
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      //选中某一顶部导航栏选项时触发
      //console.log(key, keyPath);
    },
    toUrl(path, _blank = false) {
      // 释放打开图片弹窗方法
      window.menuOperate = null;
      // 卸载标绘图层
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.plotItemLayer, true);
      this.$GLOBAL.plotItemLayer = null;

      // 卸载挖洞工具
      if (this.$GLOBAL.terrainClipGraphic) {
        this.$GLOBAL.map.removeLayer(this.$GLOBAL.terrainClipGraphic);
        this.$GLOBAL.terrainClipGraphic = null;
      }
      // 卸载挖洞工具
      if (this.$GLOBAL.terrainClip) {
        this.$GLOBAL.map.removeThing(this.$GLOBAL.terrainClip);
        this.$GLOBAL.terrainClip = null;
      }
      viewShed.modelArray.forEach((item) => {
        this.$GLOBAL.map.removeLayer(item.uid, false);
      });
      if (path == "ProjectsList") {
        if (sessionStorage.getItem("IsNew") == "new") {
          window.location.href = process.env.VUE_APP_NEW_URL + "/projects/list";
        } else {
          this.$router.push("/projectsList");
          this.$router.go(0);
        }
      } else if (!_blank) {
        let { indexProjectString } = this.$route.params;
        this.$router.push({
          name: path,
          params: {
            indexProjectString,
          },
        });
        this.$router.go(0);
        // location.reload(); //刷新当前页面
      } else {
        //新打开页面,会需要重新登录。
        const url = this.$router.resolve({
          name: path,
        });
        window.open(url.href, "_blank");
      }
    },
    loginOut() {
      //退出功能
      //弹出确认对话框
      //用户点击确认，跳回用户登录页面，清除token
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出成功!",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
          //确认退出，清除token
          //window.sessionStorage.removeItem('token')
          window.sessionStorage.clear(); //退出后清空window.sessionStorage里的内容。
          //跳转登录页面(编程式导航)
          this.$router.push("/login");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    showProjectTree() {
      this.filterText = "";
      this.searchTree = "model";
      //this.data = [];
      this.getModelTree();
    },
    filterNode(value, data) {
      this.projectTreeShow = true;
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      console.log(data);
      this.$refs.modelDetails.hideRightMenu();
      this.$refs.modelDetails.modalEditClose();
      if (data && data.children.length < 1) {
        //没有子节点
        this.$refs.tree.setCurrentKey(data.id);
        if (!data.bimModel.type) {
          if (data.bimModel.version === "wms") {
            //为线位。
            if (data.imageryLayer) {
              var layer = this.$GLOBAL.map.getLayer(data.id, "modelId");
              layer.flyTo({
                duration: 3,
              });
            } else {
              this.$alert(
                "该节点尚未被勾选，或者还没有在后台上传该节点对应的线位文件。",
                "友情提示",
                {
                  confirmButtonText: "确定",
                  type: "warning",
                  callback: (action) => {},
                }
              );
            }
          } else {
            //为模型。
            // if (data.cesium3DTilesetIndex) {
            let layer = this.$GLOBAL.map.getLayer(data.id, "modelId");

            // 会出现勾选中但是没有模型的状况
            console.log("点击", data.title);
            if (layer != undefined) {
              EventBus.$emit("updateLayerId", {
                newLayerId: data.cesium3DTilesetIndex,
                childId: data.id,
                title: data.title,
                tender: data.bimModel.tender,
              });
            } else {
              // 这里是单击节点之后跳转,应该不用调用动态挖坑方法
              // 单位单击过去之后视角会移动
              console.log("因为动态释放没有模型", data);
              if (data.cesium3DTilesetIndex)
                layer = this.createTilesetLayerNew(
                  data,
                  "handleNodeClick",
                  (e) => {
                    data.cesium3DTilesetIndex = e.layer.id;
                    EventBus.$emit("updateLayerId", {
                      newLayerId: data.cesium3DTilesetIndex,
                      childId: data.id,
                      title: data.title,
                      tender: data.bimModel.tender,
                    });
                  }
                );
            }
            layer?.flyTo({
              duration: 3,
            });
            // } else {
            // }
          }
        }
      }
    },
    handleNodeClickChange(data, status) {
      // 第一次 触发 status 不是boolean 里面包含了所有选中集合
      if (typeof status == "boolean" && data && data.children.length < 1) {
        if (!data.bimModel.type) {
          if (data.bimModel.version === "wms") {
            //为线位
            if (data.imageryLayer) {
              let layer = this.$GLOBAL.map.getLayerById(data.imageryLayer);
              if (layer) {
                this.$GLOBAL.map.removeLayer(layer, true); //移除layer。
              }
              data.imageryLayer = 0;
              let eIndex = this.$GLOBAL.checkedIds.indexOf(data.id);
              if (eIndex !== -1) {
                this.$GLOBAL.checkedIds.splice(eIndex, 1);
              }
            }
            //layer.show = status;

            if (status) {
              //展示数据
              let wmsProvider = new mars3d.layer.WmsLayer({
                //url: 'http://bim-dev:8080/geoserver/WuYuProjects/wms',
                //layers: layers[i],
                url: data.bimModel.modelUrl,
                layers: data.bimModel.modelName,
                parameters: {
                  transparent: true, //是否透明
                  format: "image/png", //application/openlayers
                  srs: "EPSG:4326",
                  styles: "",
                },
                show: true,
                hasZIndex: true,
                zIndex: data.bimModel.order || 100,
              });
              this.$GLOBAL.map.addLayer(wmsProvider);
              data.imageryLayer = wmsProvider.id;
              this.$GLOBAL.checkedIds.push(data.id);
            }
          } else {
            //为模型
            console.log("为了模型", data.cesium3DTilesetIndex);
            // if (data.cesium3DTilesetIndex) {
            let cesium3DTileset = this.$GLOBAL.map.getLayer(data.id, "modelId");
            console.log(data.cesium3DTilesetIndex);
            if (cesium3DTileset) {
              this.$GLOBAL.map.removeLayer(cesium3DTileset.uuid); //先移除旧的layer。
            }

            viewShed.inquire("modelArray", "modelId", data.id) != undefined
              ? (viewShed.inquire("modelArray", "modelId", data.id).uid = "")
              : "";

            //如果勾选项含当前选中项，则取消当前选中项的高亮【因为可以通过勾选父节点一次勾选多个模型，此举为避免混乱】。
            if (
              data.id == "NewNode-edaac84f-5019-48b3-84fd-57713ef6def6" ||
              data.id == "NewNode-37a36db7-a445-4e72-95b1-dfa572ee4aa7"
            ) {
              this.open_box = "";
            }
            if (this.currentLayerId === data.cesium3DTilesetIndex) {
              window.sessionStorage.removeItem("currentLayerId");
              window.sessionStorage.removeItem("childId");

              // <***** 施工模拟临时添加

              // 施工模拟临时添加 ******>

              this.currentLayerId = "";
              if (cesium3DTileset) {
                cesium3DTileset.closeHighlight();
              }
              if (this.$refs.tree) {
                this.$refs.tree.setCurrentKey(null);
              }
            }
            data.cesium3DTilesetIndex = 0;
            data.modelId = data.id;
            data.customize = {
              bimModelExcavationDetails: data.bimModelExcavationDetails,
            };

            let eIndex = this.$GLOBAL.checkedIds.indexOf(data.id);
            if (eIndex !== -1) {
              this.$GLOBAL.checkedIds.splice(eIndex, 1);
            }
            // }
            //cesium3DTileset.show = status; //这里status值为true

            if (status) {
              //展示数据
              // 这里是重新勾选上
              this.createTilesetLayerNew(data, "check", (e) => {
                data.modelId = e.layer.options.modelId;
                data.cesium3DTilesetIndex = e.layer.id;
                data.customize = {
                  bimModelExcavationDetails:
                    e.layer.options.customize.bimModelExcavationDetails,
                };
              });
            }
          }
        }
      } else {
        // 递归

        let state;

        if (typeof status == "boolean") {
          state = status;
        } else {
          state = status.checkedKeys.indexOf(data.id) >= "0";
        }

        if (data.children.length == 0) {
          this.handleNodeClickChange(data, state);
        } else {
          data.children.forEach((item) => {
            this.handleNodeClickChange(item, state);
          });
        }
      }
    },

    childmodal(e) {
      let { remark } = e;
      if (remark == "unity") {
        window.open("ChuanCha://");
      }
      console.log(remark);
      if (remark == "database") {
        const url = this.$router.resolve({
          name: "BimDatabank",
        });
        window.open(url.href, "_blank");
      }
      Object.keys(this.model).find((item) => {
        if (remark != item) {
          if (item != "Timeline") {
            //Timeline交组模拟组件一直打开
            this.model[item] = false;
          }
        }
      });
      console.log(this.model[remark]);
      if (this.model[remark]) {
        if (remark != "Timeline") {
          this.model[remark] = false;
        }
      } else {
        this.model[remark] = true;
      }
    },
    createTilesetLayerNew(item, type = "", fn) {
      console.log("createTilesetLayerNew", item);
      const loadModel = new Map();
      loadModel.set("init", (item) => {
        this.$GLOBAL.checkedIds.push(item.id);
        let { id, bimModelExcavationDetails, bimModel } = item;
        let {
          modelType,
          tender,
          releasedDistance,
          modelName,
          isDynamicReleased,
          modelUrl,
        } = bimModel;
        let modelColor = bimModel.modelColor ? bimModel.modelColor : undefined;
        window.bimModel
          .add(
            {
              modelId: id,
              modelType,
              modelColor,
              tender,
              releasedDistance,
              modelTitle: modelName,
              permission: isDynamicReleased,
              customize: {
                bimModelExcavationDetails,
              },
              url:
                this.$GLOBAL.projectBaseUrl +
                this.$GLOBAL.modelBasePort +
                modelUrl,
            },
            {
              click: this.modelClick,
            }
          )
          .then((e) => {
            this.renewViewShed(e);
            fn(e);
            queueMicrotask(() => {
              this.$GLOBAL.map?.removeLayer(e.layer.id, true);
            });
          });
      });

      loadModel.set("check", (item, fn) => {
        let { id, bimModelExcavationDetails, bimModel } = item;
        let {
          modelType,
          modelColor,
          tender,
          releasedDistance,
          modelName,
          isDynamicReleased,
          modelUrl,
        } = bimModel;
        window.bimModel
          .add(
            {
              modelId: id,
              modelType,
              modelColor,
              tender,
              releasedDistance,
              modelTitle: modelName,
              permission: isDynamicReleased,
              customize: {
                bimModelExcavationDetails,
              },
              url:
                this.$GLOBAL.projectBaseUrl +
                this.$GLOBAL.modelBasePort +
                modelUrl,
            },
            {
              click: this.modelClick,
            }
          )
          .then((e) => {
            this.renewViewShed(e);
            fn(e);
            //  e.layer.flyTo({
            //       duration: 3,
            //     });
          });
      });

      loadModel.set("handleNodeClick", (item, fn) => {
        let { id, bimModelExcavationDetails, bimModel } = item;
        let {
          modelColor,
          modelType,
          tender,
          releasedDistance,
          modelName,
          isDynamicReleased,
          modelUrl,
        } = bimModel;
        console.log("bimModel", bimModel);
        window.bimModel
          .add(
            {
              modelId: id,
              modelType,
              modelColor,
              tender,
              releasedDistance,
              modelTitle: modelName,
              permission: isDynamicReleased,
              customize: {
                bimModelExcavationDetails,
              },
              url:
                this.$GLOBAL.projectBaseUrl +
                this.$GLOBAL.modelBasePort +
                modelUrl,
            },
            {
              click: this.modelClick,
            }
          )
          .then((e) => {
            this.renewViewShed(e);
            fn(e);
            e.layer.openHighlight();
            e.layer.flyTo({
              duration: 3,
            });
          });
      });

      loadModel.set("resourceRelease", (item, fn) => {
        let {
          modelColor,
          modelId,
          modelType,
          tender,
          releasedDistance,
          url,
          permission,
          modelTitle,
          bimModelExcavationDetails,
        } = item;
        window.bimModel
          .add(
            {
              modelId,
              modelType,
              modelColor,
              tender,
              releasedDistance,
              modelTitle,
              permission,
              customize: {
                bimModelExcavationDetails,
              },
              url,
            },
            {
              click: this.modelClick,
            }
          )
          .then((e) => {
            this.renewViewShed(e);
            fn(e);
          });
      });

      const run = (key, item, fn) => {
        const fun = loadModel.get(key);
        fun && fun(item, fn);
      };

      run(type, item, fn);
    },

    renewViewShed(e) {
      console.log("renewViewShed", e);
      let item = viewShed.inquire(
        "modelArray",
        "modelId",
        e.layer.options.modelId
      );
      if (item != undefined) {
        item.uid = e.layer.uuid;
      } else {
        viewShed.add("modelArray", {
          permission: e.layer.options.permission,
          modelId: e.layer.options.modelId,
          modelType: e.layer.options.modelType,
          modelColor: e.layer.options.modelColor,
          modelTitle: e.layer.options.modelTitle,
          tender: e.layer.options.tender,
          url: decodeURI(e.layer.options.url),
          uid: e.layer.uuid,
          center: e.layer._center,
          customize: e.layer.options.customize,
          releasedDistance: e.layer.options.releasedDistance,
        });
        console.log("viewShed", viewShed);
      }
      this.$GLOBAL.osgbTilesetLayerIds = bimModel.bimObliquePhotographyId;
    },

    modelClick(event) {
      this.fullName = event.graphic?.attr.name?.split("@")[0];
      this.newTerrainDiggingData = null;
      this.newTerrainDiggingData = event.layer.options;
      if (this.fullName)
        // 会触发请求
        EventBus.$emit("updateLayerId", {
          tender: event.layer.options.tender,
          newLayerId: event.layer.id,
          childId: event.layer.options.modelId,
          title: event.layer.options.modelTitle,
          pickedObject: event.pickedObject, //选取的构件，方便实现构件高亮
        });
    },

    // 取构件树数据
    querySceneTreeData(url) {
      const scenetree =
        url.substring(0, url.lastIndexOf("/") + 1) + "scenetree.json";
      return mars3d.Util.fetchJson({ url: scenetree });
    },

    fillPit(testArr, index) {
      // 生成正方形
      let allX = [],
        allY = [],
        allZ = [],
        warningRange = [],
        maxX,
        maxY,
        minX,
        minY,
        minZ,
        maxZ;
      testArr.forEach((i) => {
        allX.push(i[0]);
        allY.push(i[1]);
        allZ.push(i[2]);
      });
      maxX = Math.max.apply(null, allX);
      maxY = Math.max.apply(null, allY);
      minX = Math.min.apply(null, allX);
      minY = Math.min.apply(null, allY);
      minZ = Math.min.apply(null, allZ);
      maxZ = Math.max.apply(null, allZ);
      console.log(minZ);

      warningRange.push({
        xmax: maxX,
        xmin: minX,
        ymax: maxY,
        ymin: minY,
        alt: maxZ,
        index: index,
      });

      // let graphicLayer = new mars3d.layer.GraphicLayer();
      // this.$GLOBAL.map.addLayer(graphicLayer);
      // // const primitive = new mars3d.layer.GeoJsonLayer({
      // const primitive = new mars3d.graphic.RectanglePrimitive({
      //   positions: [
      //     // [minX, minY],
      //     // [maxX, maxY],
      //     [minX, minY],
      //     [maxX, maxY],
      //   ],
      //   style: {
      //     height: minZ - 20,
      //     color: "red",
      //     opacity: 0.8,
      //     boxShadow:
      //       "0 0 0 1px hsla (0,0%, 100 %, .3) inset,0.5em 1em rgba (0, 0, 0, 0.6)",
      //   },
      //   attr: {
      //     remark: "测试填坑",
      //   },
      // });
      // graphicLayer.addGraphic(primitive); // primitive.addTo(graphicLayer)  //另外一种写法
      return warningRange;
    },

    timerClear_dom() {
      if ($(".search-results").length > 0) {
        //设置一下第三方搜索结构框里的滚动条样式，这时能获取到.search-results Dom元素。
        $(".search-results").niceScroll({
          cursorcolor: "#909399", // 改变滚动条颜色，使用16进制颜色值
          cursoropacitymin: 0.0, // 当滚动条是隐藏状态时改变透明度, 值范围 1 到 0
          cursoropacitymax: 0.3, // 当滚动条是显示状态时改变透明度, 值范围 1 到 0
          cursorwidth: "6px", // 滚动条的宽度，单位：便素
          cursorborder: "none", // CSS方式定义滚动条边框
          cursorborderradius: "3px", // 滚动条圆角（像素）
          autohidemode: "leave",
        });
        clearInterval(this.timer_dom); //清理【用于设置Dom元素滚动条】定时器
      }
    },
    // transferWidget(path) {
    // 	mars3d.widget.activate(path)
    // },
    modelTransparencyChange(val) {
      //注意这里存的是当前模型的透明度设置值。
      this.modelTransparancyValue = val;
      // console.log("ZHANG", val);
      //注意这里存的是模型的透明度设置值【可存多个】。
      let layerId = this.currentLayerId;
      //同时创建一个关于模型的记录数据对象，方便用户在主界面的地图里点击不同的模型时，记录这些模型的设置值。
      let layerObj = {
        layerId: layerId,
        transparency: val,
      };
      this.$store.dispatch("edit_layer", [layerObj]);

      let tileLayer = this.$GLOBAL.map.getLayerById(layerId);
      tileLayer.opacity = val;
    },
    clickAttribute() {
      //$('.mars3d-contextmenu').hide();
      // return false;
      // alert('触发！');
      // 右键弹窗菜单坐标点。
      // 内置的默认右键菜单获取方法
      //let defaultContextmenuItems = this.$GLOBAL.map.getDefaultContextMenu();
      let top_offset = document.getElementById("el-header").offsetHeight;
      let left_offset = document.getElementById("el-aside").offsetWidth;
      // this.$GLOBAL.map.bindContextMenu(defaultContextmenuItems, {
      // 	offsetX: left_offset,
      // 	offsetY: top_offset
      // });
      $(".mars3d-contextmenu").css(
        "left",
        $(".mars3d-contextmenu").offset().left + left_offset
      );
      $(".mars3d-contextmenu").css(
        "top",
        $(".mars3d-contextmenu").offset().top + top_offset
      );
      $(".mars3d-contextmenu").show();
    },
    // //函数防抖
    // debounce(func, wait) {
    // 	let timeout;
    // 	return function() {
    // 		let context = this;
    // 		let args = arguments;
    // 		if (timeout) clearTimeout(timeout);
    // 		timeout = setTimeout(() => {
    // 			func.apply(context, args)
    // 		}, wait);
    // 	}
    // },
    // handleScroll(e) {
    // 	// alert('触发！');
    // 	let top_offset = document.getElementById('el-header').offsetHeight;
    // 	let left_offset = document.getElementById('el-aside').offsetWidth;
    // 	let dom_wheel = document.getElementById('cesiumContainer-mars3d-mousedownview');
    // 	let top_offset2 = dom_wheel.offsetHeight;
    // 	let left_offset2 = dom_wheel.offsetWidth;
    // 	dom_wheel.style.left = '300px';
    // 	dom_wheel.style.top = '300px';
    // 	dom_wheel.style.display = 'block';
    // }

    //隐藏或展示地图左边侧边栏。
    showAsideTab() {
      //mapWork.modelAddRemove("NewNode-7bc28dda-2785-41a1-9ef2-16b0ddb7d77d","add",() => {});
      //mapWork.modelAddRemove("d21e9e8a-d6c2-4c84-84c4-1f564dde4aac","remove",() => {});
      this.showAside = !this.showAside;
      if (this.showAside) {
        let table_obj = document.getElementsByClassName("table");

        // let table_offsetL = -1;
        // if (table_obj && table_obj[0]) {
        // 	table_offsetL = Math.ceil(table_obj[0].offsetLeft);
        // }
        // if ((table_offsetL > 0 || table_offsetL === 0) && table_offsetL < this.max_aside_length) {
        // 	table_obj[0].style.left = this.max_aside_length + 'px';
        // }

        let table_offsetLA;

        if (table_obj.length > 0) {
          //alert(1);
          table_offsetLA = Array(table_obj.length).fill(-1);
          // console.log(table_offsetLA);
          for (let k = 0; k < table_obj.length; k++) {
            table_offsetLA[k] = Math.ceil(table_obj[k].offsetLeft);
            if (
              (table_offsetLA[k] > 0 || table_offsetLA[k] === 0) &&
              table_offsetLA[k] < this.max_aside_length
            ) {
              table_obj[k].style.left = this.max_aside_length + "px";
            }
          }
        }
      }
    },
    //鼠标拉缩侧边栏宽度。
    dragControllerDiv: function () {
      var resize = document.getElementsByClassName("drag-resize");
      var left = document.getElementsByClassName("el-aside");
      var mid = document.getElementsByClassName("el-main");
      var box = document.getElementsByClassName("el-container");

      var that = this;

      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = function (e) {
          var table_obj = document.getElementsByClassName("table");
          var aside_width = document.getElementById("el-aside").offsetWidth;

          let table_offsetLA;

          if (table_obj.length > 0) {
            table_offsetLA = Array(table_obj.length).fill(-1);
            for (let k = 0; k < table_obj.length; k++) {
              table_offsetLA[k] = Math.ceil(table_obj[k].offsetLeft);
            }
          }

          // let table_offsetL = -1;
          // if (table_obj && table_obj[0]) {
          // 	table_offsetL = Math.ceil(table_obj[0].offsetLeft);
          // }

          // console.log(table_offsetL);

          var startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          document.onmousemove = function (e) {
            var endX = e.clientX;
            var moveLen = resize[i].left + (endX - startX);
            var maxT = box[i].clientWidth - resize[i].offsetWidth;
            // if (moveLen < 150) moveLen = 150;
            // if (moveLen > maxT - 150) moveLen = maxT - 150;

            if (moveLen > 380) moveLen = 380;
            if (moveLen < 252) moveLen = 252;

            resize[i].style.left = moveLen;

            that.max_aside_length = moveLen;

            for (let j = 0; j < left.length; j++) {
              left[j].style.width = moveLen + "px";

              mid[j].style.width = box[i].clientWidth - moveLen + "px";
            }

            // console.log(table_obj);

            if (table_obj.length > 0) {
              for (let k = 0; k < table_obj.length; k++) {
                if (table_offsetLA[k] > 0 && table_offsetLA[k] < moveLen) {
                  table_obj[k].style.left =
                    table_offsetLA[k] + moveLen - aside_width + "px";
                  //console.log(table_obj[0].style.left);
                  let new_max_length =
                    table_offsetLA[k] + moveLen - aside_width;
                  if (new_max_length > that.max_aside_length) {
                    that.max_aside_length = new_max_length;
                  }
                }
              }
            }
            // if (table_offsetL > 0 && table_offsetL < moveLen) {
            // 	table_obj[0].style.left = table_offsetL + moveLen - aside_width + 'px';
            // 	//console.log(table_obj[0].style.left);
            // 	that.max_aside_length = table_offsetL + moveLen - aside_width;
            // }

            //console.log(that.max_aside_length);
          };
          document.onmouseup = function (evt) {
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture();
          };
          resize[i].setCapture && resize[i].setCapture();
          return false;
        };
      }
    },

    //展示MBS标准目录树。
    showMBSTree: function () {
      this.filterText = "";
      //alert('触发！');
      // console.log(this.data);
      this.searchTree = "mbs";
      let mbsArray = [
        {
          id: 1,
          title: "隧道工程",
          children: [
            {
              id: 10,
              title: "总体及装饰装修",
              children: [
                {
                  id: 11,
                  title: "装饰装修",
                  children: [
                    {
                      id: 12,
                      title: "防火涂料",
                    },
                    {
                      id: 13,
                      title: "防火涂料面漆",
                    },
                  ],
                },
                {
                  id: 14,
                  title: "隔热保温层",
                },
              ],
            },
            {
              id: 15,
              title: "主洞土建结构",
              children: [
                {
                  id: 16,
                  title: "主洞洞口与洞门",
                  children: [
                    {
                      id: 17,
                      title: "洞口开挖",
                    },
                    {
                      id: 18,
                      title: "洞口防排水",
                      children: [
                        {
                          id: 19,
                          title: "截水沟",
                        },
                        {
                          id: 20,
                          title: "排水沟",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ];
      this.data = mbsArray;
      //预留代码
      //获取 MBS目录树列表。
      // let MBSListData = {
      // 	projectId:projectId,
      // 	CurrentNode:0,
      // 	ExpandLevel:3,
      // }
      // getMBSList(MBSListData).then(res =>{
      // 	//对数据进行处理，添加MBS目录树。
      // 	let mbsArray=JSON.parse(res.data);
      // 	...
      //	mbsArray = [];
      //	this.data = mbsArray;
      // });
    },

    getGISInfo() {
      //GIS信息API
      axios
        .get(
          "https://www.chbim.cn/home/userLogin?loginUserName=" +
            this.ruleForm.user +
            "&loginPassword=" +
            this.$md5(this.ruleForm.pass),
          {
            // params: {
            //   user:this.ruleForm.user,
            // }
          }
        )
        .then(function (response) {
          //GIS信息数据
          //response.data
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getModelInfo() {
      //模型数据API
      axios
        .get(
          "https://www.chbim.cn/home/userLogin?loginUserName=" +
            this.ruleForm.user +
            "&loginPassword=" +
            this.$md5(this.ruleForm.pass),
          {
            // params: {
            //   user:this.ruleForm.user,
            // }
          }
        )
        .then(function (response) {
          //GIS信息数据
          //response.data
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    //预留代码
    // //获取当前模型的属性列表。
    // getModelProperty() {
    // 	let PropertyListData = {
    // 		id: projectId,
    // 		PartId: window.sessionStorage.getItem('currentLayerId')
    // 	}
    // 	getModelPropertyList(PropertyListData).then(res => {
    // 		//对数据进行处理，添加MBS目录树。
    // 		let proArray = JSON.parse(res.data);
    // 		//...
    // 		this.modelProList = proArray;
    // 	});
    // },

    //提示功能尚待开发中
    popUps(str = "此") {
      this.$alert(str + "功能尚待开发中,请耐心等待~", "友情提示", {
        confirmButtonText: "确定",
        type: "success",
        callback: (action) => {
          // this.$message({
          // 	type: 'info',
          // 	message: `action: ${ action }`
          // });
        },
      });
    },
    //清除功能可以去掉，因为有对应加载内容的操作面板及一些加载内容的自动清除。
    // clearThings() {
    // 	this.$message({
    // 		message: '已完成清除。',
    // 		type: 'success',
    // 		offset: 100,
    // 		showClose: true
    // 	});
    // }

    chooseBottomBtn(index) {
      if (index && this.bottomNavBtnIndex !== index) {
        this.bottomNavBtnIndex = index; //实现toggle效果。
      } else {
        this.bottomNavBtnIndex = 0;
      }
      this.topMenuOpen.map((item) => this.$refs.indexTopMenu.close(item));
    },
    verifyBottomNavBtnIndex(index) {
      return index && this.bottomNavBtnIndex === index;
    },
    initialViewingAngle() {
      let { indexProjectString } = this.$route.params;
      const projectsetCameraView =
        indexProjectString == undefined
          ? []
          : this.$route.params.indexProjectString.split(",");
      if (projectsetCameraView.length > 0) {
        // 到后面可以请后端在后台管理平台给每个项目增加一个初始视角配置项，如果项目没有配置初始视角，前端程序就设置初始视角为地球。此处是针对第一个都安项目特殊设置的。
        if (
          projectsetCameraView[5] &&
          projectsetCameraView[6] &&
          projectsetCameraView[5] != "null" &&
          projectsetCameraView[6] != "null"
        ) {
          let maxZoomDist = parseFloat(projectsetCameraView[5]);
          let minZoomDist = parseFloat(projectsetCameraView[6]);

          this.$GLOBAL.map.setCameraView({
            lng: projectsetCameraView[0],
            lat: projectsetCameraView[1],
            alt: projectsetCameraView[5], //maxZoomDist,
            heading: projectsetCameraView[3],
            pitch: projectsetCameraView[4],
          });
          const cameraOptions = {
            cameraController: {
              minimumZoomDistance: minZoomDist,
              maximumZoomDistance: maxZoomDist - 100,
            },
          };
          this.$GLOBAL.map.setSceneOptions(cameraOptions);
        } else {
          this.$GLOBAL.map.setCameraView({
            lng: projectsetCameraView[0],
            lat: projectsetCameraView[1],
            alt: projectsetCameraView[2],
            heading: projectsetCameraView[3],
            pitch: projectsetCameraView[4],
          });
        }
      } else {
        this.$GLOBAL.map.flyHome();
      }

      // 延迟12秒关闭动画，为了使结束开场动画后，第一时间展示出来的效果就比较好。
      console.log("延迟开始....");
      let stopLoadingTimer = setTimeout(() => {
        //that.$GLOBAL.loading_map_finish = true; //关闭加载动画
        that.loading2 = false; // 关闭开场动画。
        clearTimeout(stopLoadingTimer);
        console.log("延迟结束....");
      }, 1600);

      let that = this;
    },
    rightClick(MouseEvent, object, Node, element) {
      this.$refs.modelDetails.rightClick(MouseEvent, object, Node, element);
    },
    // 通过id找对象 根据视点动态释放版本 1.0
    findPnodeId(data, id) {
      //设置结果
      let result;
      if (!data) {
        return; //如果data传空，直接返回
      }
      for (var i = 0; i < data.length; i++) {
        let item = data[i];
        if (item.id == id) {
          result = item;
          //找到id相等的则返回父id
          return result;
        } else if (item.children && item.children.length > 0) {
          //如果有子集，则把子集作为参数重新执行本方法
          result = this.findPnodeId(item.children, id);
          //关键，千万不要直接return本方法，不然即使没有返回值也会将返回return，导致最外层循环中断，直接返回undefined,要有返回值才return才对
          if (result) {
            return result;
          }
        }
      }
      //如果执行循环中都没有return，则在此return
      return result;
    },
    // 创建从新创建挖坑图层
    addterrainClip() {
      if (terrainClip) {
        terrainClip.clear();
      }
      terrainClip = new mars3d.thing.TerrainClip({
        // image: "http://mars3d.cn/img/textures/poly-stone.jpg",
        // imageBottom: "http://mars3d.cn/img/textures/poly-soil.jpg",
        splitNum: 50,
      });
      this.$GLOBAL.map.addThing(terrainClip);
      this.$GLOBAL.terrainModifyClipId = terrainClip.id;
    },
    // 开启地图监听
    addEventListener() {
      // this.addterrainClip();
      const processDigJson = async ({ digModifyUrl }) => {
        let processDigData;
        await axios.get("/baseIP/" + digModifyUrl).then((data) => {
          let dataArr = [];
          for (let i = 0; i < data.data.length; i++) {
            for (let j = 0; j < data.data[i].terrainModifier.length; j++) {
              dataArr.unshift(
                JSON.parse(data.data[i].terrainModifier[j].point)
              );
            }
          }
          processDigData = dataArr;
        });
        return processDigData;
      };

      // 添加相机监听事件 为了监听相机是否能看见物体 从而挖坑
      let allDigData;
      allDigData = JSON.parse(localStorage.getItem("allDigData")).val;
      this.$GLOBAL.map.viewer.camera.moveEnd.addEventListener(() => {
        // console.log("我挖的坑", areaItem);

        if (this.$GLOBAL.map.getCameraView().pitch < -45)
          if (this.$GLOBAL.map.getCameraView().alt < 7000) {
            let digPidArr = [];
            allDigData.forEach((item) => {
              if (Object.keys(item.scope).length > 0) {
                if (
                  this.isOverlap(
                    this.$GLOBAL.map.getExtent({
                      formatNum: true,
                    }),
                    item.scope
                  )
                ) {
                  digPidArr.push(item.digPid);
                }
              }
            });
            digPidArr = [...new Set(digPidArr)];
            let projectPid = [];
            if (areaItem[digPidArr] == undefined) {
              // this.addterrainClip();
              areaItem = {};
              digPidArr.forEach((pid) => {
                allDigData.find((item) => {
                  if (item.digPid == pid) {
                    projectPid.push(item);
                  }
                });
              });
            }
            // console.log("范围内坑的坐标点", projectPid);
            projectPid.forEach((item) => {
              // console.log("范围内坑的坐标点", item);
              areaItem[item.digPid] = {
                id: item.digId,
                name: item.digName,
                mapArea: [],
              };
              processDigJson(item).then((z) => {
                if (z.length > 3) this.excavation(z, areaItem[item.digPid]);
              });
            });
          } else {
            // console.log("太高了算了");
            // this.addterrainClip();
            areaItem = {};
          }
      });
      // 添加相机监听事件 END
    },

    isOverlap(rect1, rect2) {
      console.log(rect2);
      let x1, x2, x3, x4, y1, y2, y3, y4;
      x1 = rect2.xmin;
      x2 = rect2.xmax;
      x3 = rect1.xmin;
      x4 = rect1.xmax;
      y1 = rect2.ymin;
      y2 = rect2.ymax;
      y3 = rect1.ymin;
      y4 = rect1.ymax;

      return (x4 - x1) * (x3 - x2) < 0 && (y4 - y1) * (y3 - y2) < 0;
    },

    excavation(digArr, areaItemMapArea) {
      let mapArea;
      digArr.forEach((i) => {
        i[2] = i[2] - 10;
      });
      mapArea = terrainClip.addArea(digArr, {
        diffHeight: 5,
      });
      areaItemMapArea.mapArea.push(mapArea);
    },
    openTopSubMenu(key) {
      this.topMenuOpen.push(key);
      this.bottomNavBtnIndex = 0;
      this.topMenuOpen = [...new Set(this.topMenuOpen)];
    },
    closeTopSubMenu(key) {
      this.topMenuOpen.splice(
        this.topMenuOpen.findIndex((item) => item === key),
        1
      );
    },
    showBasicSettings() {
      if (this.$refs.toolLibrary)
        Object.keys(this.$refs.toolLibrary?.model).forEach((e) => {
          this.$refs.toolLibrary.model[e] = false;
        });
      this.open_box = "BasicSettings";
    },
    initIndexDb() {
      console.log("创建数据库2");
      let dbObjs = [
        //创建KML缓存数据库
        {
          name: "kmlDb",
          key: "id", //"options.Kmlid",
          isAutoIncrement: false, //主键是否自增
          isCreateIndex: true,
          isUnique: true,
        },
        //创建SHP缓存数据库
        {
          name: "shpDb",
          key: "id",
          isAutoIncrement: false, //主键是否自增
          isCreateIndex: true,
          isUnique: true,
        },
        //创建模型缓存数据库
      ];
      indexedDbMap.init(dbObjs, (status) => {
        if (status == 0) {
          console.log("init indexedDb success");
        } else {
          console.log("init indexedDb fail");
        }
      });
    },

    clearDots() {
      if (graphicDotsine && graphicDotsine != undefined) {
        graphicDotsine.clear();
        graphicDotsine = undefined;
      }

      // graphicDotsArr = [];
    },

    transparentInit() {
      if (mapWork.underground) {
        this.transparentValue = mapWork.underground.alpha
          ? mapWork.underground.alpha
          : 1;
      }
    },
    constructionUpdateData() {
      //施工模拟，播放方案时，更新其他菜单的数据
      this.model.BaotongScheme = false;
    },
    ifTransparent(e) {
      if (!e) {
        this.transparentValue = 0;
      } else {
        this.transparentValue = 1;
      }
    },
    transparent: _.debounce(function (data) {
      mapWork.setUnderground(this.transparentValue);
      this.$GLOBAL.map?.getLayers().forEach((item) => {
        if (item.options.modelType == 0) {
          item.opacity = this.transparentValue;
        }
      });
      this.lock = false;
    }, 1000),
    // 初始化时间轴
    initAnimation(data) {
      this.ifAnimation = true;
      this.$refs["animation"].initAnimation(data);
    },
  },
  destroyed() {
    //alert(window.sessionStorage.getItem('currentLayerId'));
    document.getElementsByTagName("body")[0].className = "";
    window.sessionStorage.removeItem("currentLayerId");
    this.clearDots();
    //alert(window.sessionStorage.getItem('currentLayerId'));
    this.$GLOBAL.checkedIds = [];
    terrainClip = null;
    window.oncontextmenu = function () {
      return true;
    };
    this.$GLOBAL.osgbTilesetLayerIds = [];
    areaItemT8 = null;
    //console.log('destroyed:'+idenStr);
    if (idenStr) {
      window.sessionStorage.removeItem("idenStr");
    }
    clearTimeout(this.stopLoadingTimer2);
    this.stopLoadingTimer2 = null;
    window.viewShed = new ViewShed([], null);
  },
};
